export const Config = {
  base_url: 'https://slim.ridexcity.com',
};
